import { createStore as reduxCreateStore } from 'redux'
import reducer from './reducers'


let createStore; // eslint-disable-line

if (process.env.NODE_ENV === 'development') {
	createStore = () => reduxCreateStore(
		reducer,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	)
} else {
	createStore = () => reduxCreateStore(reducer);
}

export default createStore;



// WEBPACK FOOTER //
// ./src/state/createStore.js